import { render, staticRenderFns } from "./ServiceChargeWallet.vue?vue&type=template&id=0eed0eb4&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ServiceChargeWallet.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeWallet.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeWallet.vue?vue&type=style&index=0&id=0eed0eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eed0eb4",
  null
  
)

component.options.__file = "ServiceChargeWallet.vue"
export default component.exports